// extracted by mini-css-extract-plugin
module.exports = {"workoutPage":"WorkoutPage_workoutPage__35NAG","fadeIn":"WorkoutPage_fadeIn__2_jQd"};